import apiClient from './client'
import { Empresa, EmpresaCreate } from '../types/api'
import { ensureArray } from '../utils/array'
import { AxiosResponse } from 'axios'

export type EmpresaSortField =
  | 'id'
  | 'nome'
  | 'grupo_id'
  | 'status'
  | 'cnpj'
  | 'banco_dados'
  | 'ip'
  | 'created_at'
  | 'updated_at'

export const empresasApi = {
  list: async (
    grupoId?: number,
    options?: {
      includeInactive?: boolean
      status?: string
      sort_by?: EmpresaSortField
      sort_direction?: 'asc' | 'desc'
    }
  ): Promise<Empresa[]> => {
    const params: Record<string, unknown> = {}
    if (grupoId) {
      params.grupo_id = grupoId
    }
    if (options?.status) {
      params.status = options.status
    } else if (options?.includeInactive) {
      // IMPORTANTE: Backend espera incluir_inativas (snake_case)
      params.incluir_inativas = true
    } else {
      // Por padrão, apenas ativas
      params.status = 'A'
    }
    if (options?.sort_by) {
      params.sort_by = options.sort_by
    }
    if (options?.sort_direction) {
      params.sort_direction = options.sort_direction
    }

    const response = await apiClient.get<Empresa[]>('/empresas', { params })
    return ensureArray<Empresa>(response.data)
  },

  get: async (id: number): Promise<Empresa> => {
    const response = await apiClient.get<Empresa>(`/empresas/${id}`)
    return response.data
  },

  create: async (data: EmpresaCreate): Promise<Empresa> => {
    const response = await apiClient.post<Empresa>('/empresas', data)
    return response.data
  },

  update: async (id: number, data: Partial<EmpresaCreate>): Promise<Empresa> => {
    const response = await apiClient.put<Empresa>(`/empresas/${id}`, data)
    return response.data
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/empresas/${id}`)
  },

  /**
   * Obtém tema_config (inclui features.usar_overrides_telas)
   */
  getTema: async (id: number): Promise<Record<string, any> | null> => {
    const response: AxiosResponse<{ tema_config: Record<string, any> | null }> = await apiClient.get(`/empresas/${id}/tema`)
    return response.data?.tema_config ?? null
  },
}

